import { LoadState } from "../../constants/enums";


export interface IAutomobileCertificateofInsuranceState {
  certificateOfInsuranceList: IAutomobileCertificateofInsurance[];
  totalRecords: number;
  loading: LoadState;
}

export interface IAutomobileCertificateofInsurance {
  incremental_number: number;
  task_code: string;
  policy_number: string;
  customer_name: string;
  customer_code: string;
  policy_form_type: string;
  create_ts: string | null;
  created_by_name: number;
  status: string;
}

export const initialAutomobileCertificateofInsuranceState: IAutomobileCertificateofInsuranceState =
  {
    certificateOfInsuranceList: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
  };
